import { useTranslation } from 'react-i18next';
import { useErrorHandler } from '../hooks/use-error-handler';
import { useStorage } from '../hooks/use-storage';
import { useSwal } from '../hooks/use-swal';
import { useAnalytics } from '../utils/setup/analytics-setup';

function useErrorModal() {
  const { analyticsPageView } = useAnalytics();
  const storage = useStorage();
  const { parseErrorMessage } = useErrorHandler();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  function didOpen(message) {
    analyticsPageView(message);
  }

  async function show(error) {
    const message = parseErrorMessage(error);

    if (message != null) {
      return null;
    }

    const result = await swal.fire({
      title: t('error.exclamation'),
      text: message,
      didOpen,
      icon: 'error',
      confirmButtonText: t('close'),
    });

    return result;
  }

  return {
    showErrorModal: show,
  };
}

export { useErrorModal };
